import React from "react";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import store from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import withAuth from "utils/withAuth";
import { SnackbarProvider } from "notistack";
import Button from "@material-ui/core/Button";
// core components
import Admin from "layouts/Admin.js";
import SignIn from "views/Signin/SignIn.js";
import SnackbarInitializer from "components/SnackbarInitializer";

// Import i18n configuration
import "./i18n";

import "assets/css/material-dashboard-react.css?v=1.9.0";
import "react-credit-cards/es/styles-compiled.css";
import "assets/css/common.scss";

// Sentry removido: apontava para a instância da Twistag (sentry.twt-env.com),
// que recebia os erros e dados do backoffice. Reativar só com um Sentry da THC.

const notistackRef = React.createRef();
const onClickDismiss = key => () => {
  notistackRef.current.closeSnackbar(key);
};

ReactDOM.render(
  // <Router history={hist}>
  <SnackbarProvider
    ref={notistackRef}
    maxSnack={3}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right"
    }}
    action={key => <Button onClick={onClickDismiss(key)}>Dismiss</Button>}
  >
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}>
      <Provider store={store}>
        <SnackbarInitializer />
        <Router>
          {/* history={hist} */}
          <Switch>
            <Route path="/admin/login" component={withAuth(SignIn, true)} />
            <Route path="/admin" component={withAuth(Admin)} />
            <Redirect from="/" to="/admin/login" />
          </Switch>
        </Router>
      </Provider>
    </GoogleReCaptchaProvider>
  </SnackbarProvider>,
  document.getElementById("root")
);
